module.exports = __webpack_public_path__ + "media/images/application/icons/plus-5c4dd3da2a1f5a7729e0a0729a1bcdd6.svg";